module.exports = __webpack_public_path__ + "img/item_bg_select.da573729.png";